module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlQAAAABCAYAAAAYRDBEAAAAHklEQVRIie3BMQEAAAgDoNm/5JpoB29g2m4AAPhJcsekA6EY+OtkAAAAAElFTkSuQmCC"